// removed by extract-text-webpack-plugin
module.exports = {"sigWrap":"Signature__sigWrap__RdxkB"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/FormBuilder/Signature/Signature.css
// module id = 1240
// module chunks = 0